import {
  Logout,
} from "assets/Icon";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  useTheme,
} from "@mui/material";

import ChangeThemeButton from "components/ChangeThemeButton";
import LogoutModal from "components/SideMenuItems/Logout";
import { useState } from "react";

function SideMenuDrawer({ open, onClose }) {
  const theme = useTheme();

  const [openLogout, setOpenLogout] = useState(false);

  return (
    <>
      <DrawerStyle anchor="left" open={open} onClose={onClose}>
        <List>
          <ListItemStyle>
            <ListItemButtonStyle
              onClick={() => {
                setOpenLogout(true);
                onClose();
              }}
            >
              <ListItemIcon>
                <Logout color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="خروج" />
            </ListItemButtonStyle>
          </ListItemStyle>

          <ListItemStyle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <ChangeThemeButton />
          </ListItemStyle>
        </List>
      </DrawerStyle>

      {openLogout && (
        <LogoutModal open={openLogout} onClose={() => setOpenLogout(false)} />
      )}
    </>
  );
}

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
}));


const ListItemButtonStyle = styled(ListItemButton)(({ theme }) => ({
  flexDirection: "row-reverse",
  padding: theme.spacing(0.5, 1),
  borderRadius: "5px",

  ".MuiListItemIcon-root": {
    minWidth: "35px",
    justifyContent: "flex-end",
    color: theme.palette.common.white,
  },

  ".MuiListItemText-root": {
    textAlign: "right",
  },
}));

const DrawerStyle = styled(Drawer)(({ theme }) => ({
  ".MuiPaper-root": {
    width: "200px",
    background: theme.palette.modules.sideMenu,
    borderTopRightRadius: "15px",
    borderBottomRightRadius: "15px",
  },
}));

export default SideMenuDrawer;
